import { useState, useEffect } from 'react';

export type Lang = 'EN' | 'TR';

export function useLang(): Lang {
  const [lang, setLang] = useState<Lang>(() => {
    return ((window as unknown as Record<string, unknown>).__KODO_LANG__ as Lang) || 'EN';
  });

  useEffect(() => {
    const handler = (e: Event) => {
      setLang((e as CustomEvent<Lang>).detail);
    };
    window.addEventListener('kodo-lang-change', handler);
    return () => window.removeEventListener('kodo-lang-change', handler);
  }, []);

  return lang;
}
